<template>
  <section class="sub_contents_wrap container">
    <div class="management_top_box">
      <h4>{{ $t("management.qnaManagement") }}</h4>
    </div>
    <div class="brick_box">
      <div class="view_top">
        <div class="view_title">{{ qna.title }}</div>
        <ul class="view_info">
          <li class="view_user">{{ qna.firstRegrName }}</li>
          <li class="view_date">{{ qna.firstRegDatetime }}</li>
        </ul>
        <div class="view_file" v-if="files.length > 0 && files != null">
          <ul>
            <li>
              <span>File</span>
              <a
                v-for="(file, index) in files"
                :key="index"
                href="#"
                @click="downloadFile(file)"
              >
                {{ file.fileNm }}
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div v-if="qna.content" v-html="qna.content" class="view_t"></div>
      <table class="write_tbl">
        <tbody>
          <tr>
            <th>{{ $t("common.title") }}</th>
            <td>
              <input
                type="text"
                id="title"
                name="answerTitle"
                v-model="qna.answerTitle"
                v-validate="'required'"
                class="form-control text"
              />
            </td>
          </tr>
          <tr>
            <th>{{ $t("common.file") }}</th>
            <td>
              <uploader
                :options="options"
                class="uploader-example"
                :autoStart="false"
                :size="10"
                @file-added="filesAdded"
                @file-removed="fileRemoved"
              >
                <uploader-unsupport></uploader-unsupport>
                <uploader-drop>
                  <uploader-btn>Select or drag&drop file</uploader-btn>
                </uploader-drop>
                <uploader-list></uploader-list>
              </uploader>
              <div class="view_file" v-if="answerFiles.length > 0 && answerFiles != null">
                <ul>
                  <li>
                    <span>File</span>
                    <a v-for="(file, index) in answerFiles" :key="index" href="#">
                      {{ file.fileNm }}
                      <button @click="deleteFile(file)" class="del_bt">Del</button>
                    </a>
                  </li>
                </ul>
              </div>
            </td>
          </tr>
          <tr>
            <td colspan="2">
              <ckeditor
                name="answerContent"
                v-model="qna.answerContent"
                :config="editorConfig"
                v-validate="'required'"
              ></ckeditor>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="list_bottom_bt">
        <router-link
          to="/management/support/qna"
          class="btn btn-outline-dark btn-md m-1"
          >{{ $t("common.list") }}</router-link
        >
        <button type="button" @click="saveAnswer" class="btn btn-primary btn-md m-1">
          {{ $t("common.save") }}
        </button>
      </div>
    </div>
  </section>
</template>

<script>
import { getQna, saveQnaAnswer, getAnswerFiles } from "@/api/qna";
import { deleteFile } from "@/api/file";

export default {
  data() {
    return {
      qna: { qnaFiles: "", flag: "I" },
      editorConfig: {
        filebrowserImageUploadUrl: "/img/fileupload",
        filebrowserUploadMethod: "form",
      },
      options: {
        testChunks: false,
        chunkSize: "10", //Block size
        maxChunkRetries: 3,
      },
      files: [],
      qnaAnswer: { qnaFiles: "" },
      newFiles: [],
      answerFiles: [],
      refuseFileType: [
        "asp",
        "aspx",
        "jsp",
        "php",
        "inc",
        "cgi",
        "html",
        "htm",
        "js",
        "jar",
        "jhtml",
        "php3",
        "phtml",
      ],
    };
  },
  created() {
    if (this.$route.params.boardId != null) {
      this.fetchData();
    }
  },
  methods: {
    filesAdded(file) {
      let tmp = file.file.name;
      let fileName = tmp.split(".");
      // 파일 확장자 확인
      for (let i in this.refuseFileType) {
        if (fileName[fileName.length - 1] == this.refuseFileType[i]) {
          alert(this.$t("alert.ThisIsNotAnAllowedFile"));
          file.ignored = true;
          return;
        }
      }
      this.newFiles.push(file.file);
    },
    fileRemoved(file) {
      if (this.newFiles.length > 0) {
        for (let i = 0; i < this.newFiles.length; i++) {
          if (this.newFiles[i].name == file.file.name) {
            this.$delete(this.newFiles, i);
          }
        }
      }
    },
    async fetchData() {
      try {
        this.boardId = this.$route.params.boardId;
        const response = await getQna(this.boardId);
        this.qna = response.data.qna;
        this.qna.flag = "I";
        this.files = response.data.files;
      } catch (err) {
        console.log(err);
      }
      // 답변에 대한 파일
      if (this.qna.answerId != null) {
        try {
          const response = await getAnswerFiles(this.qna.answerId);
          this.answerFiles = response.data.files;
          this.qna.flag = "U";
        } catch (err) {
          console.log(err);
        }
      }
    },
    async saveAnswer() {
      const validForm = await this.$validator.validateAll();
      if (!validForm) return alert(this.$t("alert.plzCheckAllValues"));
      try {
        const formData = new FormData();
        console.log(this.qna.flag);
        formData.append("boardId", this.boardId);
        formData.append("answerId", this.qna.answerId);
        formData.append("answerRegrId", this.qna.answerRegrId);
        formData.append("answerTitle", this.qna.answerTitle);
        formData.append("flag", this.qna.flag);
        if (this.qna.answerContent != null) {
          formData.append("answerContent", this.qna.answerContent);
        } else {
          formData.append("answerContent", this.qnaAnswer.answerContent);
        }
        if (this.newFiles != null && this.newFiles != "") {
          for (var i = 0; i < this.newFiles.length; i++) {
            let file = this.newFiles[i];
            formData.append("qnaFiles", file);
          }
        }
        const { data } = await saveQnaAnswer(formData);
        if (data.fileMessage != null && data.message != null) {
          alert(this.$t("alert.ThisIsNotAnAllowedFile"));
        } else if (data.fileMessage == null && data.message != null) {
          alert(this.$t("alert.plzCheckAllValues"));
        }
        if (data.status) {
          this.$router.push({ name: "mgmtQnaView", query: { boardId: this.boardId } });
        } else {
          alert(this.$t("alert.ErrorPlzcontactManager"));
        }
      } catch (err) {
        console.log(err);
      }
    },
    async deleteFile(file) {
      if (!confirm(this.$t("alert.delete"))) return;
      try {
        const { data } = await deleteFile(file);
        if (data.status) {
          this.qna = "";
          this.files = [];
          alert(this.$t("alert.deletedSuccessfully"));
          this.fetchData();
        } else {
          alert(this.$t("alert.ErrorPleasecontactManager"));
        }
      } catch (err) {
        console.log(err);
      }
    },
  },
};
</script>

<style></style>
